import PropTypes from "prop-types";

import ManageTemplateTable from "./ManageTemplateTable";
import LoadingSvg from "../loadingSvg/LoadingSvg.jsx";

import "../../styles/SchoolHome.scss";
import "../../styles/Updates.scss";

/**
 * This is the At a Glance section on school admin home
 * @name AtAGlance
 * @returns {JSX.Element}
 */
const AtAGlance = ({ applicableGrades, combinedGrades, loader, statusClass }) => {
    return (
        <div className="at-a-glance-container">
            <span className="sub-section-title">At a Glance</span>
            <div className="sub-section-line" />
            {!loader && statusClass === "waiting" && (
                <div className="glance-info-card">
                    <div
                        className="glance-info-text"
                        style={{ display: "flex", alignItems: "flex-start", gap: "10px" }}
                    >
                        <i
                            className="bi bi-hourglass-split"
                            style={{ fontSize: "1.3rem", marginTop: "2px", flexShrink: 0, color: "#C8860A" }}
                        />
                        <div>
                            <div style={{ fontWeight: 600, marginBottom: "4px" }}>Waiting on District Template</div>
                            <div>
                                The district template for this school year is not yet available. Please check back
                                later.
                            </div>
                        </div>
                    </div>
                    <div className="glance-info-text glance-border-top">
                        <div style={{ fontWeight: 600, marginBottom: "8px" }}>While you wait</div>
                        <div style={{ marginBottom: "6px" }}>
                            Now is a great time to review and set up your School-Level Expectations (SLEs). Click{" "}
                            <strong>SLEs</strong> in the sidebar to:
                        </div>
                        <ul style={{ paddingLeft: "20px", margin: 0, lineHeight: "1.8" }}>
                            <li>
                                Copy forward last year&apos;s SLEs as a starting point, or create new ones if this is
                                your first year.
                            </li>
                            <li>Review and edit SLEs to reflect any updates for the new year.</li>
                            <li>Ensure your SLEs are ready for teachers to use when the district template arrives.</li>
                        </ul>
                    </div>
                </div>
            )}
            {!loader && statusClass === "ready" && (
                <div className="glance-info-card">
                    <div
                        className="glance-info-text"
                        style={{ display: "flex", alignItems: "flex-start", gap: "10px", marginBottom: "16px" }}
                    >
                        <i
                            className="bi bi-check-circle-fill"
                            style={{ fontSize: "1.3rem", color: "#84ae30", marginTop: "2px", flexShrink: 0 }}
                        />
                        <div>
                            <div style={{ fontWeight: 600, marginBottom: "4px" }}>District Template Ready</div>
                            <div>
                                The district template is complete. Click <strong>School Template</strong> in the sidebar
                                to create your school&apos;s Report Card template.
                            </div>
                        </div>
                    </div>
                    <div className="glance-info-text glance-border-top">
                        <div style={{ fontWeight: 600, marginBottom: "8px" }}>Next Steps</div>
                        <ol style={{ paddingLeft: "20px", margin: 0, lineHeight: "1.8" }}>
                            <li>Create your school template from the district template.</li>
                            <li>Define the reporting periods for each content item by grade and subject.</li>
                            <li>Release completed grade templates to your teachers.</li>
                        </ol>
                    </div>
                </div>
            )}
            {!loader && (statusClass === "in-progress" || statusClass === "released") && combinedGrades && (
                <div className="glance-manage-table">
                    <ManageTemplateTable applicableGrades={applicableGrades} combinedGrades={combinedGrades} />
                </div>
            )}
            {loader && (
                <div>
                    <LoadingSvg />
                </div>
            )}
        </div>
    );
};

export default AtAGlance;

AtAGlance.propTypes = {
    applicableGrades: PropTypes.instanceOf(Array),
    combinedGrades: PropTypes.instanceOf(Array),
    loader: PropTypes.bool,
    statusClass: PropTypes.string
};
